import { AcornsIcon } from '@acorns/icons'
import { BackButton, Button, Heading } from '@acorns/web-components'
import styled from 'styled-components'

import { theme } from 'theme'

const BackButtonContainer = styled.div`
  left: 0;
  position: absolute;
  top: -65px;
  width: 100%;
`
const BackButtonStyled = styled(BackButton)`
  margin-right: 16px;
  @media screen and (max-width: ${theme('breakpoints.sm')}px) {
    left: 0;
    position: absolute;
  }
`

const HeaderCopy = styled(Heading)`
  color: ${theme('colors.slate')};
  padding: 10px 0 5px 0;
`

const A4HeaderSubcopy = styled.div`
  color: ${theme('colors.slate')};
  font-size: 14px;
  font-weight: normal;
  line-height: 22px;
  max-width: 340px;
  text-align: center;
  margin-bottom: 10px;
`

const A4ResendButton = styled.a`
  cursor: pointer;
  color: ${theme('colors.green')};
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 30px;
  text-align: center;
  &:hover {
    text-decoration: underline;
  }
`

const HeaderSubcopy = styled.div`
  color: ${theme('colors.slate')};
  font-size: 14px;
  font-weight: normal;
  line-height: 22px;
  padding: 10px 0 0px 0;
`

const HeaderSubcopyBolded = styled.span`
  color: ${theme('colors.slate')};
  font-size: 14px;
  font-weight: bold;
  line-height: 22px;
  padding: 10px 0 0px 0;
`

const ResendButton = styled(Button)`
  background: #fff;
  border: 0;
  cursor: pointer;

  font-size: 14px;
  font-weight: 600;
  margin: 0 auto;
  text-align: center;
  width: 195px;
  &:hover {
    text-decoration: underline;
  }
`

const SubmitButton = styled(Button)`
  width: 100%;
`

const A4SubmitButton = styled(Button)`
  margin: auto;
  max-width: 340px;
  width: 100%;
`

const SwitchModeButton = styled(Button)`
  color: ${theme('colors.slate')};
  font-size: 12px;
  margin: 0 auto;
  text-align: center;
  width: 200px;

  &:hover {
    text-decoration: underline;
  }
`

const A4SwitchModeButton = styled.a`
  margin: auto;
  color: ${theme('colors.slate')};
  font-size: 12px;
  text-align: center;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`

const SwitchModeContainer = styled.div`
  margin: 20px;
`

const A4SwitchModeContainer = styled.div`
  margin-top: 20px;
`

const SwitchModeIcon = styled(AcornsIcon)`
  margin-right: 10px;
`

const A4SwitchModeIcon = styled(AcornsIcon)`
  margin-right: 17px;
`

const NeedHelpButton = styled(Button)`
  text-align: center;
  margin: 20px auto auto auto;
`

const A4BottomContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 335px;
`

const BottomContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`

const BottomMargin = styled.div`
  height: 10px;
  margin-bottom: 10px;
`

const TrustThisDeviceContainer = styled.div`
  min-height: 20px;
`

const A4TrustThisDeviceContainer = styled.div`
  margin-top: 19px;
  margin-right: 135px;
`

export {
  BackButtonContainer,
  BackButtonStyled,
  BottomContainer,
  BottomMargin,
  ResendButton,
  HeaderCopy,
  HeaderSubcopy,
  HeaderSubcopyBolded,
  NeedHelpButton,
  SubmitButton,
  SwitchModeButton,
  SwitchModeContainer,
  SwitchModeIcon,
  TrustThisDeviceContainer,
  A4SubmitButton,
  A4HeaderSubcopy,
  A4BottomContainer,
  A4TrustThisDeviceContainer,
  A4ResendButton,
  A4SwitchModeButton,
  A4SwitchModeIcon,
  A4SwitchModeContainer,
}
